export default __webpack_public_path__ + "static/force-usa_cover-big_1-080c2ab4191ce35ec2e2638338473c2b.png";